(function () {
  function getInCartSvg() {
    const tpl = document.getElementById('swf-icon-in-cart-template');
    return tpl ? tpl.innerHTML : null;
  }

  function swapToInCart(button) {
    if (!button || button.classList.contains('swf-cart-btn--in-cart')) return;
    const svg = button.querySelector('svg');
    const inCartSvg = getInCartSvg();
    if (svg && inCartSvg) {
      svg.outerHTML = inCartSvg;
    }
    button.classList.add('swf-cart-btn--in-cart');
  }

  function markVariantAsInCart(variantId) {
    if (!variantId) return;
    document
      .querySelectorAll(`.swf-cart-form input[name="id"][value="${variantId}"]`)
      .forEach((input) => {
        const button = input.closest('form')?.querySelector('.swf-cart-btn');
        swapToInCart(button);
      });
  }

  /* ----- Header cart pill ----- */

  // The desktop "filled" cart icon (shown only when the cart has items).
  const FILLED_CART_ICON =
    '<svg class="swf-cart-icon swf-cart-icon--filled" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M6.66732 18.3327C7.12756 18.3327 7.50065 17.9596 7.50065 17.4993C7.50065 17.0391 7.12756 16.666 6.66732 16.666C6.20708 16.666 5.83398 17.0391 5.83398 17.4993C5.83398 17.9596 6.20708 18.3327 6.66732 18.3327Z" stroke="#D2232A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M15.8333 18.3327C16.2936 18.3327 16.6667 17.9596 16.6667 17.4993C16.6667 17.0391 16.2936 16.666 15.8333 16.666C15.3731 16.666 15 17.0391 15 17.4993C15 17.9596 15.3731 18.3327 15.8333 18.3327Z" stroke="#D2232A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M1.70898 1.70898H3.37565L5.59232 12.059C5.67363 12.438 5.88454 12.7769 6.18874 13.0172C6.49294 13.2575 6.87141 13.3843 7.25898 13.3757H15.409C15.7883 13.375 16.1561 13.2451 16.4515 13.0072C16.747 12.7693 16.9524 12.4378 17.034 12.0673L18.409 5.87565H4.26732" fill="#D2232A"/>' +
    '<path d="M1.70898 1.70898H3.37565L5.59232 12.059C5.67363 12.438 5.88454 12.7769 6.18874 13.0172C6.49294 13.2575 6.87141 13.3843 7.25898 13.3756H15.409C15.7883 13.375 16.1561 13.2451 16.4515 13.0072C16.747 12.7693 16.9524 12.4378 17.034 12.0673L18.409 5.87565H4.26732" stroke="#D2232A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  // Port of Shopify's standard money formatter, driven by shop.money_format.
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    const match = formatString.match(placeholderRegex);
    let value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function updateHeaderCart(cart) {
    const wrap = document.querySelector('.swf-header__cart-wrap');
    if (!wrap || !cart) return;

    const link = wrap.querySelector('.swf-header__cart');
    if (!link) return;

    const count = cart.item_count || 0;
    const hasItems = count > 0;
    const moneyFormat = wrap.dataset.moneyFormat || '${{amount}}';
    const total = formatMoney(cart.total_price, moneyFormat);

    // Count badge.
    let badge = wrap.querySelector('.swf-header__cart-badge');
    if (hasItems) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'swf-header__cart-badge';
        badge.setAttribute('aria-hidden', 'true');
        wrap.insertBefore(badge, link);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }

    // Has-items state + filled icon.
    link.classList.toggle('swf-header__cart--has-items', hasItems);
    let filled = link.querySelector('.swf-cart-icon--filled');
    if (hasItems && !filled) {
      const outline = link.querySelector('.swf-cart-icon--outline');
      if (outline) outline.insertAdjacentHTML('afterend', FILLED_CART_ICON);
    } else if (!hasItems && filled) {
      filled.remove();
    }

    // Label + accessible name.
    const label = link.querySelector('.swf-header__cart-label');
    if (label) label.textContent = hasItems ? total : 'Cart';
    link.setAttribute(
      'aria-label',
      `Cart, ${count} ${count === 1 ? 'item' : 'items'}${hasItems ? ', ' + total : ''}`
    );

    document.dispatchEvent(new CustomEvent('swf:cart-icon-updated'));
  }

  let headerRefreshing = false;

  async function refreshHeaderCart() {
    if (!document.querySelector('.swf-header__cart-wrap') || headerRefreshing) return;
    headerRefreshing = true;
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const cart = await (await fetch(`${root}cart.js`)).json();
      updateHeaderCart(cart);
    } catch (error) {
      console.error('[cart-icon-sync] failed to refresh header cart', error);
    } finally {
      headerRefreshing = false;
    }
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      window.addEventListener('load', init, { once: true });
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.productVariantId) {
        markVariantAsInCart(String(event.productVariantId));
      }
      // Prefer the cart payload on the event when present (saves a request),
      // otherwise fetch /cart.js for the authoritative totals.
      const cartData = event && event.cartData;
      if (cartData && typeof cartData.item_count === 'number') {
        updateHeaderCart(cartData);
      } else {
        refreshHeaderCart();
      }
    });
  }

  init();
})();
